<nav class="navbar navbar-expand-lg nav-section">
    <div class="container">
        <a class="navbar-brand" routerLink="/wgiacm"><img src="assets/images/logo-southbay.svg" class="logo"
                alt="AC Hotel by Marriott Airport Parking Application"></a>
        <!--   <a class="ml-auto mr-1"></a>
       <button class="btn btn-success ml-auto mr-1">Always open</button> -->

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
            <span class="navbar-toggler-icon"><i class="ri-menu-3-line"></i></span>
        </button>
        <div class="collapse navbar-collapse flex-grow-0" id="navbarSupportedContent">

        </div>
    </div>
</nav>
<section class="section-admin-wrap section-login">
    <section class="section-banner">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="left-box">
                        <h1>Forgot Password</h1>
                        <form [formGroup]="forgotpasswordForm" class="login-container" autocomplete="on"
                            (ngSubmit)="forgetPassword()">
                            <!-- <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pad-right">
                                <div class="input-group mb-3">
                                  <div class="input-group-prepend">
                                    <span class="input-group-text widthoficon" id="basic-addon1"><i class="ri-mail-send-fill"></i> Email</span>
                                  </div>
                                  <input type="text" class="form-control" name="fromdate" placeholder="">
                                </div>
                            </div>
                        </div> -->
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pad-right">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text widthoficon" id="basic-addon1"><i
                                                    class="ri-mail-send-fill"></i> Email</span>
                                        </div>
                                        <input type="text" class="form-control" formControlName="email"
                                            autocomplete="on">
                                        <div *ngIf="isValid && formControls.email.errors" class="help-block">
                                            <div *ngIf="formControls.email.errors.required">Email is required</div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row" id="havepromocode">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  pad-right">
                                    <a routerLink="/wgiacm" class="promo-content"><i class="ri-arrow-left-line"></i>
                                        Back to Login</a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                    <button type="submit" class="btn btn-warning btn-reserve">Send Mail</button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <p> &copy; 2020 AC Hotels by Marriott. All rights reserved</p>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <ul class="navbar">
                    <li><a routerLink="/about" routerLinkActive="active" class="nav-item">About</a></li>
                    <li><a routerLink="/contact" routerLinkActive="active" class="nav-item">Contact</a></li>
                    <li><a routerLink="/terms-privacy" routerLinkActive="active" class="nav-item">Terms & Privacy</a>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</footer>
